<div class="d-flex overflow-hidden flex-column h-100">
  <div
    class="imaging-board-header"
    [ngClass]="{ active: (hasFilters$ | async) }"
  >
    <button
      *ngIf="canCreateNewVettingRequests$ | async"
      class="new-vetting-request-button"
      id="new-vetting-request-button"
      type="button"
      mat-stroked-button
      (click)="openVettingRequestDialog()"
    >
      New Vetting Request
    </button>
    <div class="filter-warning" *ngIf="hasFilters$ | async">
      <mat-icon
        svgIcon="filled-warning-triangle"
        class="title-icon primary mr-2"
      ></mat-icon>
      <div *ngIf="hasResults">
        A search or filter is applied. This may limit the results shown -
      </div>
      <div *ngIf="!hasResults">
        There are no results matching the filter or search criteria -
      </div>
      <button
        id="clear-filters-and-search"
        mat-icon-button
        (click)="clearFiltersAndSearch()"
      >
        Clear All
      </button>
    </div>
    <div class="search">
      <form [formGroup]="searchForm">
        <input
          [ngClass]="{ active: (hasSearchTerm$ | async) }"
          placeholder="Patient Search"
          formControlName="searchTerm"
          class="search-input"
          autocomplete="off"
          id="imaging-request-search"
          (keydown.enter)="submitSearch($event)"
        />
        <button
          (click)="submitSearch($event)"
          *ngIf="(hasSearchTerm$ | async) === false"
          class="search-button"
          mat-icon-button
          matSuffix
        >
          <mat-icon class="mat-evericon">search</mat-icon>
        </button>
        <button
          (click)="clearSearch()"
          *ngIf="hasSearchTerm$ | async"
          class="search-button"
          mat-icon-button
          matSuffix
        >
          <mat-icon class="mat-evericon">close</mat-icon>
        </button>
      </form>
    </div>
    <div class="filters">
      <app-imaging-requests-filters
        [referringDoctors]="referringDoctors$ | async"
        (urgencyTypeFiltersUpdated)="updateFilteredUrgencyTypes($event)"
        (doctorFiltersUpdated)="updateFilteredDoctors($event)"
      ></app-imaging-requests-filters>
    </div>
  </div>
  <div
    class="imaging-board"
    [ngClass]="{ hasReferralCols: showReferralColumns$ | async }"
  >
    <div id="status-column-action-needed" class="column">
      <div class="column-title">
        <h4 class="column-title-text">Action Needed</h4>
      </div>
      <div class="column-content">
        <app-imaging-requests-column
          class="w-100"
          [imagingRequests]="
            getImagingRequestsByStatus(imagingRequestStatus.ActionNeeded)
              | async
          "
          [userCanEditimagingRequests]="userCanEditImagingRequests$ | async"
        >
        </app-imaging-requests-column>
      </div>
    </div>
    <div
      id="status-column-referral-in-progress"
      class="column"
      *ngIf="showReferralColumns$ | async"
    >
      <div class="column-title">
        <h4 class="column-title-text">Referral in Progress</h4>
      </div>
      <div class="column-content">
        <app-imaging-requests-column
          class="w-100"
          [imagingRequests]="
            getImagingRequestsByStatus(imagingRequestStatus.ReferralInProgress)
              | async
          "
          [userCanEditimagingRequests]="userCanEditImagingRequests$ | async"
        ></app-imaging-requests-column>
      </div>
    </div>
    <div
      id="status-column-approved-declined"
      class="column"
      *ngIf="showReferralColumns$ | async"
    >
      <div class="column-title">
        <h4 class="column-title-text">Referral Approved / Declined</h4>
      </div>
      <div class="column-content">
        <app-imaging-requests-column
          class="w-100"
          [imagingRequests]="
            getImagingRequestsByStatus(imagingRequestStatus.ApprovedOrDeclined)
              | async
          "
          [userCanEditimagingRequests]="userCanEditImagingRequests$ | async"
        ></app-imaging-requests-column>
      </div>
    </div>
    <div id="status-column-receiving-order-details" class="column">
      <div class="column-title">
        <h4 class="column-title-text">Receiving Order Details</h4>
      </div>
      <div class="column-content">
        <app-imaging-requests-column
          class="w-100"
          [imagingRequests]="
            getImagingRequestsByStatus(
              imagingRequestStatus.ReceivingOrderDetails
            ) | async
          "
          [userCanEditimagingRequests]="userCanEditImagingRequests$ | async"
        ></app-imaging-requests-column>
      </div>
    </div>
    <div id="status-column-ready-to-report" class="column">
      <div class="column-title">
        <h4 class="column-title-text">Ready to Report</h4>
      </div>
      <div class="column-content">
        <app-imaging-requests-column
          class="w-100"
          [imagingRequests]="
            getImagingRequestsByStatus(imagingRequestStatus.ReadyToReport)
              | async
          "
          [userCanEditimagingRequests]="userCanEditImagingRequests$ | async"
        ></app-imaging-requests-column>
      </div>
    </div>
    <div id="status-column-report-completed" class="column">
      <div class="column-title">
        <h4 class="column-title-text">Report Completed</h4>
      </div>
      <div class="column-content">
        <app-imaging-requests-column
          class="w-100"
          [imagingRequests]="
            getImagingRequestsByStatus(imagingRequestStatus.ReportCompleted)
              | async
          "
          [userCanEditimagingRequests]="userCanEditImagingRequests$ | async"
        ></app-imaging-requests-column>
      </div>
    </div>
  </div>
</div>
